import { CardActionArea, CardMedia as MuiCardMedia, Grid } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useIntl } from "react-intl";

import { formatItem } from "@framework/exchange";
import type { ITemplate } from "@framework/types";
import { Card, Typography } from "@dzambalaorg/ui-kit";

import { TemplatePurchaseButton } from "../../buttons";

interface IErc721TemplateListItemProps {
  template: ITemplate;
  path: string;
}

export const TemplateListItem = (props: IErc721TemplateListItemProps) => {
  const { template, path } = props;

  const { formatMessage } = useIntl();

  return (
    <CardActionArea component={RouterLink} to={`${path}/${template.id}`}>
      <Card
        header={
          <Card.Header
            title={<MuiCardMedia image={template.imageUrl} />}
            subheader={
              <Typography variant="h5" color="textPrimary">
                {template.title}
              </Typography>
            }
          />
        }
      >
        <Card.Content>
          <Grid container size={12} mb={1}>
            <Grid size={4}>
              <Typography
                variant="body1"
                fontWeight={700}
              >{`${formatMessage({ id: "pages.marketplace.templates.price" })}:`}</Typography>
            </Grid>
            <Grid size={8}>
              <Typography variant="body1" color="textSecondary" component="p">
                {formatItem(template.price)}
              </Typography>
            </Grid>
          </Grid>
        </Card.Content>

        <Card.Footer>
          <Grid container alignItems="center">
            <TemplatePurchaseButton template={template} />
          </Grid>
        </Card.Footer>
      </Card>
    </CardActionArea>
  );
};
